/**
 * Le téléphone couché, dans un projet (chantier telephone-couche, 01, décisions d'Igor du
 * 2026-10-22) : une feuille couchée, un projet ou une branche où l'on est entré, prend la vue
 * couchée (l'Analyse et la Hiérarchie). Une tâche (rien dedans, sous un projet) garde la version
 * de l'ordinateur, dans le cadre couché que toute page prend couchée (`cadre/Cadre.tsx`).
 */
export function prendLaVueCouchee(feuille: { chemin: readonly unknown[]; enfants: readonly unknown[] }): boolean {
  return feuille.chemin.length <= 1 || feuille.enfants.length > 0;
}

/** Les deux vues du projet couché. */
export type VueCouchee = 'analyse' | 'hierarchie';

/** La vue couchée choisie dure la visite, d'un projet à l'autre (comme « Montrer ce qui est fait »). */
let vueChoisie: VueCouchee = 'analyse';

export function vueCouchee(): VueCouchee {
  return vueChoisie;
}

export function choisirLaVueCouchee(vue: VueCouchee): void {
  vueChoisie = vue;
}
